export const scrollIntoViewRef =
  (block: ScrollLogicalPosition = "nearest") =>
  (node: HTMLElement | null) => {
    node?.scrollIntoView({ block })
  }
